import "./AddComponentDialog.scss";
import Dialog from "../../../dialogs/Dialog";
import { useState } from "react";
import DropDownList from "../../../forms/DropDownList";
export default function LineDialog({ setOpen, isOpen, setBuildArea, count, editData, parentSetOpen }) {
    const [lineType, setLineType] = useState(editData ? editData.line : 'solid');

    const lineTypes = [
        { value: "solid", label: "Plná" },
        { value: "dotted", label: "Bodkovaná" },
        { value: "dashed", label: "Čiarkovaná" },
        { value: "double", label: "Dvojitá" },
    ];

    const handleClose = () => {
        setLineType("empty");
        setOpen(false);
        if (parentSetOpen)
            parentSetOpen(false)
    }

    const addLine = () => {
        setBuildArea(prev => {
            const newBuildArea = [...prev];
            newBuildArea.splice(count, 0, { type: "line", line: lineType });
            return newBuildArea;
        });

    }

    const editLine = () => {
        setBuildArea(prev => prev.map((row, rowI) => {
            if (rowI === editData.rowIndex)
                return { type: "line", line: lineType }
            return row
        }))
    }

    const handleSave = (e) => {
        e.preventDefault()
        if (editData) {
            editLine();
        }
        else {
            addLine();
        }
        handleClose();
    };

    return (
        <Dialog
            title={editData ? "Nastavenia čiary" : "Nová čiara"}
            isOpen={isOpen}
            onClose={handleClose}
            onConfirm={handleSave}
            className={"AkcUiDesigner"}
            level={1}
            width={window.innerWidth / 3}>
            <div className="add-dialog-body">
                <div className="form-group">
                    <label htmlFor="lineType">Čiara</label>
                    <DropDownList
                        name="lineType"
                        className="add-dialog-form-control"
                        id="lineType"
                        value={lineTypes.find(item => item.value === lineType)}
                        onChange={(_, value) => setLineType(value.value)}
                        data={lineTypes}
                        textField="label"
                        dataItemKey="value"
                    >
                    </DropDownList>
                </div>
            </div>
        </Dialog >
    )
}
